module.exports = __webpack_public_path__ + "static/media/7.8fdda345.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row4/7.wav
// module id = 82
// module chunks = 0